import { last } from 'lodash';
import moment from 'moment';

export default {
    // to standardize all display dates
    methods: {
        dateFormat(date) {
            var getZone = localStorage.getItem('getZone');
            var getZoneoffset = localStorage.getItem('getZoneoffset');
            if (getZoneoffset == null || getZone == null) {
                var getZoneoffset = window.slurp.auth.franchise
                    ? window.slurp.auth.franchise.timezone_offset
                    : null;
                var getZone = window.slurp.auth.franchise
                    ? window.slurp.auth.franchise.timezone
                    : null;
                if (getZoneoffset == null || getZone == null) {
                    var getZoneoffset = '+08:00';
                    var getZone = 'Asia/Kuala_Lumpur';
                }
            }
            var getid = localStorage.getItem('active_outlet');
            var utc = moment.utc(date);
            var stillUtc = moment.utc(date).toDate(getZone);
            var local = moment(date)
                .local()
                .format('YYYY-MMM-DD HH:mm:ss');

            // var zoneTime = stillUtc.toLocaleString('en-US', {
            //     timeZone: getZone,
            // }); // based on zone
            var offset = moment(utc).utcOffset(getZoneoffset); //based on offset

            if (localStorage.getItem('timezones') === 'UTC') {
                var timezone = utc;
            } else if (localStorage.getItem('timezones') === 'Local') {
                var timezone = offset;
            }

            return moment(timezone)
                .format('DD MMM YYYY HH:mm:ss')
                .toUpperCase();
        },

        dateFromatModal(date, offset) {
            if (offset == null || offset == '') {
                var offset = window.slurp.auth.franchise
                    ? window.slurp.auth.franchise.timezone_offset
                    : null;
                if (offset == null || offset == '') {
                    var offset = '+08:00';
                }
            }
            var utc = moment.utc(date);
            var timezone = moment(utc).utcOffset(offset); //based on offset
            return moment(timezone)
                .format('DD MMM YYYY HH:mm:ss')
                .toUpperCase();
        },
        monthFormat(date) {
            var getZone = localStorage.getItem('getZone');
            var getZoneoffset = localStorage.getItem('getZoneoffset');
            if (getZoneoffset == null || getZoneoffset == '') {
                var getZoneoffset = window.slurp.auth.franchise
                    ? window.slurp.auth.franchise.timezone_offset
                    : null;
                var getZone = window.slurp.auth.franchise
                    ? window.slurp.auth.franchise.timezone
                    : null;
                if (getZoneoffset == null || getZoneoffset == '') {
                    var getZoneoffset = '+08:00';
                    var getZone = 'Asia/Kuala_Lumpur';
                }
            }
            var utc = moment.utc(date);

            var offset = moment(utc).utcOffset(getZoneoffset); //based on offset

            if (localStorage.getItem('timezones') === 'UTC') {
                var timezone = utc;
            } else if (localStorage.getItem('timezones') === 'Local') {
                var timezone = offset;
            }

            return moment(timezone)
                .format('MMM YYYY')
                .toUpperCase();
        },

        dateOnly(date) {
            return moment(date, 'YYYY-MM-DDTHH:mm:ss[Z]')
                .format('DD MMM YYYY')
                .toUpperCase();
        },

        timeOnly(date, offset) {
            // Default offset to '+08:00' if it's null or an empty string
            offset =
                offset ||
                (window.slurp.auth.franchise
                    ? window.slurp.auth.franchise.timezone_offset
                    : '+08:00');

            var utc = moment.utc(date);
            var timezone = moment(utc).utcOffset(offset); //based on offset
            return moment(timezone)
                .format('HH:mm:ss')
                .toUpperCase();
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/date-format.js